var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.625 20.385v-9.2h21.75v9.273c0 3.793-2.387 6.125-6.207 6.125H9.82c-3.785 0-6.196-2.38-6.196-6.198zm5.993-2.973c-.55.026-1.003-.41-1.027-.965 0-.556.43-1.015.979-1.04.537 0 .979.423.99.966a.993.993 0 01-.942 1.04zm4.906 0c-.55.026-1.003-.41-1.027-.965 0-.556.43-1.015.98-1.04.536 0 .978.423.99.966a.993.993 0 01-.943 1.04zm4.87 4.447a1.023 1.023 0 01-.99-1.027 1.004 1.004 0 01.978-1.026h.012c.561 0 1.015.459 1.015 1.026a1.02 1.02 0 01-1.015 1.027zm-5.897-1.027c.024.555.478.992 1.027.966a.992.992 0 00.943-1.038.988.988 0 00-.99-.968c-.55.026-.98.484-.98 1.04zm-4.918 0c.024.555.478.992 1.027.966a.992.992 0 00.943-1.038.988.988 0 00-.991-.968c-.55.026-.979.484-.979 1.04zm9.837-4.398c0-.555.43-1.002.978-1.015.538 0 .967.434.991.967.012.556-.418 1.015-.955 1.026a.984.984 0 01-1.014-.965v-.012z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M3.629 11.186c.015-.71.075-2.117.187-2.57.573-2.548 2.52-4.167 5.3-4.398h10.768c2.758.243 4.727 1.873 5.3 4.398.111.441.171 1.86.187 2.57H3.629z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.035 7.963c.526 0 .92-.397.92-.93V3.349c0-.533-.394-.932-.92-.932-.525 0-.919.399-.919.932v3.684c0 .533.394.93.92.93zM18.965 7.963a.91.91 0 00.92-.93V3.349a.91.91 0 00-.92-.932c-.525 0-.92.399-.92.932v3.684c0 .533.395.93.92.93z"
  }))));
}

export default SvgIconCalendar;